import React from "react";
import { useNavigate } from "react-router-dom";
import SubscriptionPlans from "../SubscriptionPlans/SubscriptionPlans";
import "./PricingPage.css";

const PricingPage = () => {
  const navigate = useNavigate();

  return (
    <div className="pricing-page" style={{ backgroundColor: '#eff2ff', minHeight: '100vh' }}>
      <header className="page-header" style={{
        padding: '1.5rem 2rem',
        background: 'linear-gradient(to right, rgba(255,255,255,0.9), rgba(239,242,255,0.9))',
        backdropFilter: 'blur(8px)',
        borderBottom: '1px solid rgba(0,0,0,0.05)',
        display: 'flex',
        alignItems: 'center',
        gap: '1.5rem'
      }}>
        <button 
          onClick={() => navigate('/')} 
          className="back-button"
          style={{
            padding: '0.5rem 1rem',
            borderRadius: '0.5rem',
            border: '1px solid rgba(0,0,0,0.1)',
            background: 'white',
            color: '#4B5563',
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            transition: 'all 0.2s ease',
            boxShadow: '0 1px 2px rgba(0,0,0,0.05)'
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.background = '#f3f4f6';
            e.currentTarget.style.transform = 'translateX(-2px)';
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.background = 'white';
            e.currentTarget.style.transform = 'translateX(0)';
          }}
        >
          <i className="fas fa-arrow-left"></i> Back
        </button>
        <h1 style={{
          margin: 0,
          fontSize: '1.5rem',
          fontWeight: '600',
          color: '#1F2937',
          background: 'linear-gradient(to right, #4F46E5, #7C3AED)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent'
        }}>Subscription Plans</h1>
      </header>
      <div className="pricing-container">
        <SubscriptionPlans readOnly={true} />
      </div>
    </div>
  );
};

export default PricingPage; 